import React from 'react'
import Select from 'react-select'
import SetsAddCompForm from '../settings/SetsAddCompForm'
import { fnum, sortOpts, getChanges } from '../../utils/utils'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import Form from '../ui/Form'

export default class EditCostForm extends Form {

  constructor(props){
    super(props);
    this.state = {
      data: this.props.data,
      delConf: false,
      showCreateComp: false,
      errors: {}
    };
  }

  savePost = (e) => {
    e.preventDefault();
    const oldD = this.props.data;
    const { data } = this.state;
    const toSend = getChanges(data, oldD);
    if(!Object.keys(toSend).length) {
      this.props.cancelEdit();
    }
    else {
      if (toSend.post_seller) {
        toSend.update_pmnts_seller = 1;
      }
      toSend.post_id = data.post_id;
      this.props.editPost(toSend, err => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        this.props.cancelEdit();
        const diff = data.post_price*data.post_qntt - oldD.post_price*oldD.post_qntt;
        this.props.updtBlnc(0, 0, diff);
      });
    }
  }

  deletePost = (e) => {
    e.preventDefault();
    const oldD = this.props.data;
    this.props.editPost({
      post_id: oldD.post_id,
      post_active: 0
    }, err => {
      if (err) {
        this.setState({errors: err});
        return;
      }
      this.props.cancelEdit();
      const diff = -oldD.post_price*oldD.post_qntt;
      this.props.updtBlnc(0, 0, diff);
    });
  }

  showCreateComp = () => {
    this.setState({
      showCreateComp:true
    });
  }

  hideCreateComp = () => {
    this.setState({
      showCreateComp:false
    });
  }

  selectAddedComp = id => {
    this.setState({
      data:{
        ...this.state.data,
        post_seller:id
      }
    });
  }

  render() {
    const { srvgs, ctypes, comps } = this.props;

    const showCreateComp = this.state.showCreateComp ?
      <SetsAddCompForm
        afterSave={this.selectAddedComp}
        addSets={this.props.addSets}
        onCancel={this.hideCreateComp}
        srvgs={srvgs}
        ctypes={ctypes}
        data={{
          comp_desc: '',
          comp_long: '',
          comp_city: '',
          comp_addr: '',
          comp_tel: '',
          comp_email: '',
          comp_note: '',
          comp_own: 0,
          comp_order: 0,
          comp_expense: 0,
          comp_cost: 1,
          comp_empl: 0,
          comp_ctype_id: 0,
          comp_srvg_ids: '',
          comp_active: 1
        }}
      />
      : '';

    const { data, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deletePost}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    var compsOpt = [];
    for (let key in comps){
      if(comps.hasOwnProperty(key)){
        if(
          (
            comps[key].comp_active === 1 &&
            comps[key].comp_cost === 1
          ) ||
          comps[key].comp_id === data.post_seller
        ) {
          compsOpt.push({value:comps[key].comp_id,label:comps[key].comp_desc});
        }
      }
    }
    compsOpt.sort(sortOpts);

    return (
      <tr>
        <td>
          {showCreateComp}
          <div className="form-group">
            <button  type="button" className="btn btn-success btn-xs"
              onClick={this.savePost}
              title="Сохранить"
            >
              <span className="glyphicon glyphicon-save"></span>
            </button>
          </div>
          <div className="form-group">
            <button type="button" className="btn btn-default btn-xs"
              onClick={this.props.cancelEdit}
              title="Отменить"
            >
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          <div className="form-group">
            <button type="button" className="btn btn-danger btn-xs"
              onClick={this.toggleDelConf}
              title="Удалить"
            >
              <span className="glyphicon glyphicon-trash"></span>
            </button>
          </div>
          {delConf}
        </td>
        <td>
          <div className="form-group">
            <textarea type="text"
              className="form-control"
              name="post_desc"
              value={data.post_desc}
              rows="3"
              title="Описание"
              placeholder="Описание"
              onChange={this.updateInput}
            />
          </div>
          <div className="form-group">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <label>Подрядчик&nbsp;</label>
              <div style={{flex: 1, width: 0}}>
                <Select
                  clearable={false}
                  options={compsOpt}
                  value={data.post_seller}
                  onChange={e => this.updateSelect(e,'post_seller')}
                />
              </div>
              <button type="button" className="btn btn-default"
                onClick={this.showCreateComp}
                title="Создать подрядчика"
              >
                <span className="glyphicon glyphicon-plus"></span>
              </button>
            </div>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td className="form-group">
          <input type="text"
            className="form-control text-editable"
            value={data.post_price}
            name="post_price"
            onChange={this.updateInput}
          />
        </td>
        <td className="form-group">
          <input type="text"
            className="form-control text-editable"
            value={data.post_qntt}
            name="post_qntt"
            onChange={this.updateInput}
          />
        </td>
        <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
        <td className="form-group" colSpan="3">
          <textarea type="text"
            className="form-control"
            value={data.post_note}
            rows="3"
            placeholder="Заметка"
            title="Заметка"
            name="post_note"
            onChange={this.updateInput}
          />
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/prs/PRSEditCostForm.js